import { $themeBreakpoints } from '@themeConfig'
import { getIsDeviceMobile } from '../utils/utils'

export default {
    namespaced: true,
    state: {
        windowWidth: 0,
        shallShowOverlay: false,
        route: null,
    },
    getters: {
        currentBreakPoint: state => {
            const { windowWidth } = state
            if (windowWidth >= $themeBreakpoints.xl) return 'xl'
            if (windowWidth >= $themeBreakpoints.lg) return 'lg'
            if (windowWidth >= $themeBreakpoints.md) return 'md'
            if (windowWidth >= $themeBreakpoints.sm) return 'sm'
            return 'xs'
        },
        isMobile: () => {
            const isMobileDevice = getIsDeviceMobile()

            return isMobileDevice
        },
    },
    mutations: {
        UPDATE_WINDOW_WIDTH(state, val) {
            state.windowWidth = val
        },

        SET_ROUTE(state, route) {
            state.route = route
        },
    },
    actions: {},
}
